import type { DateRange } from '../types'

export enum RevenueMiscellaneousActionTypes {
  SET_SETTLEMENT_ID = 'SET_SETTLEMENT_ID',
  SET_DISBURSEMENT_START_END_DATE = 'SET_DISBURSEMENT_START_END_DATE',
  SET_REQUEST_PROCESSED_DATE = 'SET_REQUEST_PROCESSED_DATE',
  SET_DISBURSEMENT_SIDE_PANEL_LOADING = 'SET_DISBURSEMENT_SIDE_PANEL_LOADING',
}

export type { DateRange }

export interface RevenueDisbursementSidePanel {
  startDateOfMonth: string
  endDateOfMonth: string
  settlementId: string
  requestedForDatetime: string
  disbursementSidePanelLoading: number
}

export const initialRevenueDisbursementSidePanelState: RevenueDisbursementSidePanel =
  {
    startDateOfMonth: '',
    endDateOfMonth: '',
    settlementId: '',
    requestedForDatetime: '',
    disbursementSidePanelLoading: 0,
  }

export type RevenueDisbursementSidePanelAction =
  | {
      type: RevenueMiscellaneousActionTypes.SET_DISBURSEMENT_START_END_DATE
      payload: DateRange
    }
  | {
      type: RevenueMiscellaneousActionTypes.SET_SETTLEMENT_ID
      payload: string
    }
  | {
      type: RevenueMiscellaneousActionTypes.SET_REQUEST_PROCESSED_DATE
      payload: string
    }
  | {
      type: RevenueMiscellaneousActionTypes.SET_DISBURSEMENT_SIDE_PANEL_LOADING
      payload: boolean
    }
